import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.loadTotals()
  }

  async loadTotals() {
    const url = this.data.get('url')
    if (!url) {
      console.error('report-totals: No URL provided')
      return
    }

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (!response.ok) throw new Error('Failed to load totals')

      const totals = await response.json()
      this.updateTotals(totals)
    } catch (error) {
      console.error('Error loading totals:', error)
      this.showError()
    }
  }

  updateTotals(totals) {
    // Update count
    const countCell = this.element.querySelector('[data-total="count"]')
    if (countCell) countCell.textContent = totals.count

    // Integer fields (not currency)
    const integerFields = [
      'quantity', 'received_quantity', 'total_pq', 'pq', 'incoming',
      'qty', 'sku_qty', 'total_units', 'inventory_qty'
    ]
    integerFields.forEach(field => {
      const cell = this.element.querySelector(`[data-total="${field}"]`)
      if (cell && totals[field] !== undefined) {
        cell.textContent = totals[field].toLocaleString()
      }
    })

    // Currency totals
    const currencyFields = [
      'subtotal', 'shipping', 'tax', 'total', 'profit',
      'total_paid', 'owing', 'sales', 'cost', 'total_price',
      'total_cost', 'unit_sell', 'total_sell', 'total_line_items',
      'total_fulfilled', 'total_returns',
      'restocking_fee', 'shipping_refund', 'return_total',
      'supplier_cost', 'total_tax', 'total_shipping', 'total_items',
      'total_amount_received', 'total_amount_paid', 'total_pa', 'pa',
      'unit_cost', 'initial_balance', 'balance', 'amount',
      'opening_balance', 'closing_balance', 'inventory_value',
      'ordered', 'paid', 'net_balance', 'unapplied_credits', 'unpaid_invoices',
      'current', 'one_thirty', 'thirty_sixty', 'sixty_ninty', 'ninty_one_twenty',
      'more_than_one_twenty'
    ]
    currencyFields.forEach(field => {
      const cell = this.element.querySelector(`[data-total="${field}"]`)
      if (cell && totals[field] !== undefined) {
        cell.textContent = this.formatCurrency(totals[field])
      }
    })
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount)
  }

  showError() {
    // Find all cells with data-total attribute that show "Loading..." and replace with error indicator
    const cells = this.element.querySelectorAll('[data-total]')
    cells.forEach(cell => {
      if (cell.textContent.trim() === 'Loading...') {
        cell.innerHTML = '<span class="text-danger" title="Failed to load">—</span>'
      }
    })
  }
}
